import axios from '@/api/config';

const tencentVideoInfo = {
  getTencentVideoInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/tencentVideoInfo/getTencentVideoInfo/` + data, {});
  },
  getTencentVideoInfo(data) {
    return axios.get(`${process.env.BASE_URL}/tencentVideoInfo/getTencentVideoInfo`, {params: data});
   },
  getTencentVideoInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/tencentVideoInfo/getTencentVideoInfoList`, {params: data});
  },
  getTencentVideoInfoTree(data) {
    return axios.get(`${process.env.BASE_URL}/tencentVideoInfo/getTencentVideoInfoTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/tencentVideoInfo/pageList`, data);
  },
  addTencentVideoInfo(data) {
    return axios.post(`${process.env.BASE_URL}/tencentVideoInfo/addTencentVideoInfo`, data);
  },
  updateTencentVideoInfo(data) {
    return axios.put(`${process.env.BASE_URL}/tencentVideoInfo/updateTencentVideoInfo`, data);
  },
  deleteTencentVideoInfo(data) {
    return axios.delete(`${process.env.BASE_URL}/tencentVideoInfo/deleteTencentVideoInfo`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/tencentVideoInfo/exportExcel`, {params: data});
  },
  getTencentVideoTypeTree(data) {
    return axios.get(`${process.env.BASE_URL}/tencentVideoType/getTencentVideoTypeTree`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/tencentVideoInfo/importData`, data);
  },
  importExcelCheck(data) {
    return axios.post(`${process.env.BASE_URL}/tencentVideoInfo/importExcelCheck`, data);
  },
}

export default tencentVideoInfo;



// WEBPACK FOOTER //
// ./src/api/tencentVideoInfo.js